import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrganizationSelectionService {
  private readonly orgIdSubject = new BehaviorSubject<number | null>(null);
  readonly orgId$ = this.orgIdSubject.asObservable();

  setOrgId(id: number | null): void {
    this.orgIdSubject.next(id);
  }

  get currentOrgId(): number | null {
    return this.orgIdSubject.getValue();
  }
}
